import React, {useState} from 'react';

import {useInjectSaga} from 'utils/injectSaga';
import pagesSaga from 'sagas/foldersSaga';
import documentsSaga from 'sagas/documentsSaga';
import categorySaga from 'sagas/categorySaga';
import {getLabelArray, Menus} from 'enums';
import {useDispatch} from 'react-redux';
import {fetchFolderSuccess} from 'actions/categoryActions';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Tabs from 'components/Tabs';
import history from 'utils/history';
import Chart from './Chart';

import Sitemap from './Sitemap';
import People from './People';
import Pages from './Pages';
import Roles from './Roles';
import Statics from './Statics';
import Files from './File';
import Icons from './Icons';
import Documents from './Documents';
import 'styles/dashboard.scss';
import 'styles/new-post.scss';
import Team from './Team';

const Admin = ({match}) => {
  useInjectSaga({key: 'pages', saga: pagesSaga});
  useInjectSaga({key: 'category', saga: categorySaga});
  useInjectSaga({key: 'documents', saga: documentsSaga});
  const dispatch = useDispatch();
  const {tabId, folderId} = match.params;

  const tabs = getLabelArray(Menus);
  const selectedTab = tabs.find((f) => f.label.toLowerCase() === tabId);
  const [menu, setMenu] = useState(selectedTab || tabs[1]);

  const renderSections = () => {
    if (!menu) return null;

    switch (menu.label) {
      case Menus.Sitemap:
        return <Sitemap />;
      case Menus.People:
        return <People />;
      case Menus.Pages:
        return <Pages />;
      case Menus.Role:
        return <Roles />;
      case Menus.Statistics:
        return <Statics />;
      case Menus.Team:
        return <Team />;
      case Menus.Images:
        return <Files folderId={folderId} />;
      case Menus.Icons:
        return <Icons folderId={folderId} />;
      case Menus.documents:
        return <Documents folderId={folderId} />;

      default:
        return (
          <div className="dashboard-list ">
            <div className="table-responsive statics-list"></div>
          </div>
        );
    }
  };

  return (
    <>
      <Header />
      <div className="wrapper">
        <Sidebar />
        <div className="content_wrapper">
          <Chart />
          <div className="tab-box">
            <Tabs
              tabs={tabs}
              active={menu}
              onChange={(e) => {
                setMenu(e);
                history.push(`/admin/${e.label.toLowerCase()}`);
                dispatch(fetchFolderSuccess(null));
              }}
            />
          </div>
          <div className="tab-content p-4 bg-white min-height">
            {renderSections()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
